'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Link = require('../Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a react router <Link /> that looks like a bootstrap button.
 */
var ButtonLink = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ButtonLink, _Component);

    function ButtonLink() {
        (0, _classCallCheck3.default)(this, ButtonLink);
        return (0, _possibleConstructorReturn3.default)(this, (ButtonLink.__proto__ || (0, _getPrototypeOf2.default)(ButtonLink)).apply(this, arguments));
    }

    (0, _createClass3.default)(ButtonLink, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'children', 'rel', 'secondary', 'small', 'target', 'url']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                children = _props.children,
                external = _props.external,
                secondary = _props.secondary,
                small = _props.small,
                rel = _props.rel,
                target = _props.target,
                url = _props.url;

            var button = (0, _jsx3.default)(_Button2.default, {
                className: className,
                primary: true,
                secondary: secondary,
                small: small
            }, void 0, children);

            return external ? (0, _jsx3.default)(_Link2.default, {
                to: url,
                target: target,
                rel: rel
            }, void 0, button) : (0, _jsx3.default)(_Link2.default, {
                route: true,
                to: url,
                rel: rel
            }, void 0, button);
        }
    }]);
    return ButtonLink;
}(_react.Component), _class.defaultProps = {
    className: '',
    external: false,
    secondary: false,
    small: false
}, _temp);
exports.default = ButtonLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ButtonLink/ButtonLink.js
// module id = bCbI
// module chunks = 46